export default __webpack_public_path__ + "static/media/rogue.17c73747.jpeg";